/**
 * Tabs section – switches visible panel when a tab is clicked.
 */
function initTabs() {
  const sections = document.querySelectorAll('.tabs-section');

  sections.forEach((section) => {
    const tablist = section.querySelector('[role="tablist"]');
    const triggers = /** @type {NodeListOf<HTMLButtonElement>} */ (section.querySelectorAll('[data-tab-trigger]'));
    const panels = section.querySelectorAll('.tabs-section__panel');

    if (!tablist || triggers.length === 0 || panels.length === 0) return;

    // Use labels from panel data (block template has access to block.settings.heading)
    triggers.forEach((trigger, i) => {
      const panel = panels[i];
      const label = panel?.getAttribute('data-tab-label');
      if (label) trigger.textContent = label;
    });

    /**
     * @param {number} activeIndex
     */
    function switchToIndex(activeIndex) {
      triggers.forEach((t, i) => {
        const isActive = i === activeIndex;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
        t.classList.toggle('tabs-section__tab--active', isActive);
      });
      panels.forEach((p, i) => {
        const isActive = i === activeIndex;
        p.classList.toggle('tabs-section__panel--active', isActive);
        if (isActive) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        if (panels[index]) switchToIndex(index);
      });
    });

    tablist.addEventListener('keydown', (/** @type {KeyboardEvent} */ e) => {
      const currentIndex = Array.from(triggers).findIndex((t) => t.getAttribute('aria-selected') === 'true');
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        nextIndex = (currentIndex + 1) % triggers.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        nextIndex = (currentIndex - 1 + triggers.length) % triggers.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        nextIndex = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        nextIndex = triggers.length - 1;
      }

      const nextTrigger = triggers[nextIndex];
      if (nextIndex !== currentIndex && nextTrigger) {
        nextTrigger.click();
        nextTrigger.focus();
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabs);
} else {
  initTabs();
}

document.addEventListener('shopify:section:load', initTabs);
